/** Passgate JWT 本地存储（与 brood-passgate 外部应用约定一致） */

const ACCESS_KEY = 'simulation_platform_passgate_access_token';
const REFRESH_KEY = 'simulation_platform_passgate_refresh_token';

export const PASSGATE_RETURN_PATH_KEY = 'passgate_post_login_redirect';

export function savePassgateTokens(accessToken: string, refreshToken?: string | null): void {
  localStorage.setItem(ACCESS_KEY, accessToken);
  if (refreshToken) {
    localStorage.setItem(REFRESH_KEY, refreshToken);
  }
}

export function getPassgateAccessToken(): string | null {
  return localStorage.getItem(ACCESS_KEY);
}

export function getPassgateRefreshToken(): string | null {
  return localStorage.getItem(REFRESH_KEY);
}

export function clearPassgateTokens(): void {
  localStorage.removeItem(ACCESS_KEY);
  localStorage.removeItem(REFRESH_KEY);
}
